'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineModels = defineModels;

var _SummaryByDateReport = require('./models/SummaryByDateReport');

var _SummaryByDateReport2 = _interopRequireDefault(_SummaryByDateReport);

var _SummaryByTickerReport = require('./models/SummaryByTickerReport');

var _SummaryByTickerReport2 = _interopRequireDefault(_SummaryByTickerReport);

var _TariffChanges = require('./models/TariffChanges');

var _TariffChanges2 = _interopRequireDefault(_TariffChanges);

var _TariffWithDetails = require('./models/TariffWithDetails');

var _TariffWithDetails2 = _interopRequireDefault(_TariffWithDetails);

var _Tariff = require('./models/Tariff');

var _Tariff2 = _interopRequireDefault(_Tariff);

var _TradingParameters = require('./models/TradingParameters');

var _TradingParameters2 = _interopRequireDefault(_TradingParameters);

var _WithdrawRequest = require('./models/WithdrawRequest');

var _WithdrawRequest2 = _interopRequireDefault(_WithdrawRequest);

var _OvernightFeeCalculationParameters = require('./models/OvernightFeeCalculationParameters');

var _OvernightFeeCalculationParameters2 = _interopRequireDefault(_OvernightFeeCalculationParameters);

var _RejectWithdrawRequest = require('./models/rpc/RejectWithdrawRequest');

var _RejectWithdrawRequest2 = _interopRequireDefault(_RejectWithdrawRequest);

var _ReportUserRequest = require('./models/rpc/ReportUserRequest');

var _ReportUserRequest2 = _interopRequireDefault(_ReportUserRequest);

var _BalanceRequest = require('./models/rpc/BalanceRequest.js');

var _BalanceRequest2 = _interopRequireDefault(_BalanceRequest);

var _BalanceResponse = require('./models/rpc/BalanceResponse.js');

var _BalanceResponse2 = _interopRequireDefault(_BalanceResponse);

var _AppliedTariffRequest = require('./models/rpc/AppliedTariffRequest.js');

var _AppliedTariffRequest2 = _interopRequireDefault(_AppliedTariffRequest);

var _TradingParametersChangeRequest = require('./models/rpc/TradingParametersChangeRequest.js');

var _TradingParametersChangeRequest2 = _interopRequireDefault(_TradingParametersChangeRequest);

var _TariffResponse = require('./models/rpc/TariffResponse.js');

var _TariffResponse2 = _interopRequireDefault(_TariffResponse);

var _DepositTradingAccountRequest = require('./models/rpc/DepositTradingAccountRequest');

var _DepositTradingAccountRequest2 = _interopRequireDefault(_DepositTradingAccountRequest);

var _WithdrawTradingAccountRequest = require('./models/rpc/WithdrawTradingAccountRequest');

var _WithdrawTradingAccountRequest2 = _interopRequireDefault(_WithdrawTradingAccountRequest);

var _TariffsResponse = require('./models/rpc/TariffsResponse');

var _TariffsResponse2 = _interopRequireDefault(_TariffsResponse);

var _TariffWithDetailsResponse = require('./models/rpc/TariffWithDetailsResponse');

var _TariffWithDetailsResponse2 = _interopRequireDefault(_TariffWithDetailsResponse);

var _TradingParametersResponse = require('./models/rpc/TradingParametersResponse');

var _TradingParametersResponse2 = _interopRequireDefault(_TradingParametersResponse);

var _ByIdRequest = require('./models/rpc/ByIdRequest');

var _ByIdRequest2 = _interopRequireDefault(_ByIdRequest);

var _ByUserRequest = require('./models/rpc/ByUserRequest');

var _ByUserRequest2 = _interopRequireDefault(_ByUserRequest);

var _ByUserAndMarketRequest = require('./models/rpc/ByUserAndMarketRequest');

var _ByUserAndMarketRequest2 = _interopRequireDefault(_ByUserAndMarketRequest);

var _TariffCustomizationResponse = require('./models/rpc/TariffCustomizationResponse');

var _TariffCustomizationResponse2 = _interopRequireDefault(_TariffCustomizationResponse);

var _TariffCustomizationChangeRequest = require('./models/rpc/TariffCustomizationChangeRequest');

var _TariffCustomizationChangeRequest2 = _interopRequireDefault(_TariffCustomizationChangeRequest);

var _CreateTariffSwitchRequestByAdmin = require('./models/rpc/CreateTariffSwitchRequestByAdmin');

var _CreateTariffSwitchRequestByAdmin2 = _interopRequireDefault(_CreateTariffSwitchRequestByAdmin);

var _CreateTariffSwitchRequest = require('./models/rpc/CreateTariffSwitchRequest');

var _CreateTariffSwitchRequest2 = _interopRequireDefault(_CreateTariffSwitchRequest);

var _BrokerFee = require('./models/rpc/BrokerFee');

var _BrokerFee2 = _interopRequireDefault(_BrokerFee);

var _ExecutionsReportForAdminRequest = require('./models/rpc/ExecutionsReportForAdminRequest');

var _ExecutionsReportForAdminRequest2 = _interopRequireDefault(_ExecutionsReportForAdminRequest);

var _SummaryByDateReportForAdminRequest = require('./models/rpc/SummaryByDateReportForAdminRequest');

var _SummaryByDateReportForAdminRequest2 = _interopRequireDefault(_SummaryByDateReportForAdminRequest);

var _CreateTariffRequest = require('./models/rpc/CreateTariffRequest');

var _CreateTariffRequest2 = _interopRequireDefault(_CreateTariffRequest);

var _ScriptTradingParameters = require('./models/rpc/ScriptTradingParameters');

var _ScriptTradingParameters2 = _interopRequireDefault(_ScriptTradingParameters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * nobody can reference to rpc-request or rpc-response, so this models defined in the end of domain models
 */
function defineRpcModels(domainBuilder) {
  (0, _ReportUserRequest2.default)(domainBuilder);
  (0, _BalanceRequest2.default)(domainBuilder);
  (0, _BalanceResponse2.default)(domainBuilder);
  (0, _AppliedTariffRequest2.default)(domainBuilder);
  (0, _TradingParametersChangeRequest2.default)(domainBuilder);
  (0, _TariffResponse2.default)(domainBuilder);
  (0, _DepositTradingAccountRequest2.default)(domainBuilder);
  (0, _WithdrawTradingAccountRequest2.default)(domainBuilder);
  (0, _TariffsResponse2.default)(domainBuilder);
  (0, _TariffWithDetailsResponse2.default)(domainBuilder);
  (0, _TradingParametersResponse2.default)(domainBuilder);
  (0, _TariffCustomizationResponse2.default)(domainBuilder);
  (0, _TariffCustomizationChangeRequest2.default)(domainBuilder);
  (0, _CreateTariffSwitchRequestByAdmin2.default)(domainBuilder);
  (0, _CreateTariffSwitchRequest2.default)(domainBuilder);
  (0, _ByIdRequest2.default)(domainBuilder);
  (0, _ByUserRequest2.default)(domainBuilder);
  (0, _ByUserAndMarketRequest2.default)(domainBuilder);
  (0, _WithdrawRequest2.default)(domainBuilder);
  (0, _RejectWithdrawRequest2.default)(domainBuilder);
  (0, _BrokerFee2.default)(domainBuilder);
  (0, _ExecutionsReportForAdminRequest2.default)(domainBuilder);
  (0, _SummaryByDateReportForAdminRequest2.default)(domainBuilder);
  (0, _CreateTariffRequest2.default)(domainBuilder);
  (0, _ScriptTradingParameters2.default)(domainBuilder);
}

function defineModels(domainBuilder) {
  (0, _SummaryByDateReport2.default)(domainBuilder);
  (0, _SummaryByTickerReport2.default)(domainBuilder);
  (0, _TariffChanges2.default)(domainBuilder);
  (0, _TariffWithDetails2.default)(domainBuilder);
  (0, _Tariff2.default)(domainBuilder);
  (0, _TradingParameters2.default)(domainBuilder);
  (0, _OvernightFeeCalculationParameters2.default)(domainBuilder);

  defineRpcModels(domainBuilder);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models.js
// module id = 1429
// module chunks = 118